import {PluginSettings} from '@wordpress/plugins';
import Pages from './pages/Edit';
import Categories from './categories/Edit';
import {addAction, addFilter} from '@wordpress/hooks';
import {Initialize, initializeAccordions} from './Accordion';
import {FunctionComponent} from 'react';
import type {StyleOptions} from './WidgetStyles';

export const name = 'advanced-sidebar-menu-pro-blocks';

type SideloadProps = {
	clientId: string
}

export const settings: PluginSettings = {
	icon: 'welcome-widgets-menus',
	render: () => {
		// Remove the info panel from the basic version.
		addFilter( 'advanced-sidebar-menu.blocks.info-panel', 'advanced-sidebar-menu-pro', () => () => null );

		// Remove the exclude field from the basic version.
		addFilter( 'advanced-sidebar-menu.blocks.exclude-field', 'advanced-sidebar-menu-pro', () => () => null );

		// Initialize the accordions on preview change.
		addAction<Initialize>( 'advanced-sidebar-menu.blocks.preview.loading-finished', 'advanced-sidebar-menu', initializeAccordions );

		// Prevent closing a section from reloading the preview.
		addFilter( 'advanced-sidebar-menu.blocks.preview.attributes', 'advanced-sidebar-menu-pro', ( attr: StyleOptions ) => {
			return {...attr, closed_sections: []};
		} );

		// Default functionality using `PluginArea` to load our `Fills`.
		if ( 'undefined' === typeof window.wp.customize ) {
			return ( <>
				<Categories />
				<Pages />
			</> );
		}

		// Side load the Fills into the Customizer.
		addFilter<FunctionComponent<SideloadProps>>( 'advanced-sidebar-menu.blocks.side-load', 'advanced-sidebar-menu-pro', SideLoad => ( props: SideloadProps ) => (
			<SideLoad {...props}>
				<Categories />
				<Pages />
			</SideLoad> )
		);

		return null;
	},
};
